import Component_FresnelParameters_347ed77eb087b93c2d7d95d09d3ab72f from "../../../../content/examples/textures/fresnel-parameters/FresnelParameters";
import Devtool_FresnelParameters_347ed77eb087b93c2d7d95d09d3ab72f from "!!@devtool/loader!../../../../content/examples/textures/fresnel-parameters/FresnelParameters";
import { DevTool } from '@devtool/react';
import * as React from 'react';
export default {
  Component_FresnelParameters_347ed77eb087b93c2d7d95d09d3ab72f,
  Devtool_FresnelParameters_347ed77eb087b93c2d7d95d09d3ab72f,
  DevTool,
  React
};